export default __webpack_public_path__ + "static/media/H.1ea306f5.svg";